import 'es5-shim'
import 'es6-shim'
import WebpackerReact from 'webpacker-react'

// Import components
import Auth from '../components/application/auth'
import ForgotPassword from '../components/application/forgot_password'
import Impersonate from '../components/application/impersonate'
import Gdpr from '../components/application/gdpr'
import Verify from '../components/application/verify'

// Repack components
WebpackerReact.setup({ Auth, ForgotPassword, Impersonate, Gdpr, Verify })



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js